import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListControl } from "../../components/ui/list/ListControl";
import { TableView } from "../../components/ui/list/TableView";
import { getReceptionistColumns } from "./columns";
import { CreateButton } from "../../components/ui/Button";

export default function ReceptionistList() {

  const { setBreadcrumb } = useApplication();

  const actions = [
    deactivateAction('receptionist', 'receptionist'),
    activateAction('receptionist', 'receptionist'),
    deleteAction('receptionist', 'receptionist')
  ];

  const statuses = [{
    text: 'Active',
    value: true
  }, {
    text: 'Inactive',
    value: false
  }];

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Receptionistes',
        current: true
      }
    ]);
  });

  return (
    <>
      <div class="flex">
        <CreateButton href="/receptionist/create">New Receptionist</CreateButton>
      </div>
      <Card class="w-full">
        <CardContent>
          <ListControl
            search={''}
            mode="table"
            actions={actions}
            filters={[
              {
                type: 'choice',
                label: 'Status',
                name: 'status',
                choices: statuses,
                default: null
              },
              {
                type: 'date',
                label: 'Created At',
                name: 'created_at',
                default: null
              }
            ]}
            sort={{
              column: 'created_at',
              direction: 'asc'
            }}
            pagination={{
              current: 1, // default 1
              changePerPage: true, // default true
              perPage: 10, // default 10
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/receptionist/fetch',
                method: 'GET',
                params: {
                  //status: status()
                }
              }
            }}
          >{(innerProps) => <TableView actionKey='key' {...innerProps} columns={getReceptionistColumns({ onListAction: innerProps.onAction })} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
